// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"671b1a29","455":"5e4b6c0f","977":"b4534850"}[chunkId] + ".chunk.js";
};